import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function AboutDirector() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-76">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-77">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-78">
          {/* Left Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%] text-center lg:text-left" data-id="element-79">
            <span className="text-[#FF1493] uppercase text-[13px] font-bold tracking-[2px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-80">
              OUR MEDICAL DIRECTOR
            </span>

            <h2 className="text-[28px] sm:text-4xl lg:text-[48px] uppercase text-white leading-tight mb-8 font-[600] font-[Poppins,_sans-serif]" data-id="element-81">
              FIONA FRIE, MD
            </h2>

            <div className="space-y-6 text-[#B0B0B0] text-base leading-[1.7] font-body" data-id="element-82">
              <p data-id="element-83">
                Fiona Frie, MD is an internist, who is double-trained and
                certified, having qualified and practiced in both the UK
                (Anesthesiology) and in the US (Internal Medicine).
              </p>
              <p data-id="element-84">
                Dr. Frie received her medical degree from The Royal London
                Hospital and St. Bartholomew's Medical College in London. After
                postgraduate training in Anesthetics, she and her American-born
                husband moved to the US, where she completed a second residency
                at Kaiser Hospital in San Francisco, performing a finishing year
                at Albany Medical Center in Albany, New York.
              </p>
            </div>
          </AnimateOnScroll>

          {/* Right Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-85">
            <div className="relative mx-auto max-w-[400px] lg:max-w-none" data-id="element-86">
              <div className="absolute -inset-4 border-r-4 border-b-4 border-[#FF1493] rounded-lg opacity-50 hidden lg:block" data-id="element-87"></div>
              <img src="https://cdn.magicpatterns.com/uploads/fDEhsEc7YJpKVAYRkyFKV8/ChatGPT_Image_Feb_13,_2026,_12_14_45_PM_2.png" alt="Dr. Fiona Frie, MD" className="w-full h-[400px] lg:h-[600px] object-cover rounded-lg relative z-10" data-id="element-88" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-lg z-20" data-id="element-89"></div>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}